import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import Rx from 'rx-lite';
import { logException } from 'utils/log/logError';
import $ from 'jquery';
import * as variables from 'variables';
import DirectioNewsList from '../components/DirectioNewsList';

const scadenzeDirectioTmpl = require('portale/scadenze.dust');

export default function configHomepage() {
	const newsDirectioBox = document.getElementById('js-react-directionews');
	if (newsDirectioBox) {
		Rx.Observable.fromPromise($.getJSON(`${variables._webApiServiceDomain}v1/directio/news?callback=?`, { limit: 3 }).promise())
			.retry(3)
			.subscribe((data) => {
				ReactDOM.render(<DirectioNewsList items={data.result} />, newsDirectioBox);
			}, (error) => {
				logException(error);
			});
	}

	const $scadenzeDirectioBox = $('.js-scadenze-directio');
	if ($scadenzeDirectioBox.length) {
		$.getJSON(`${variables.directioCMSapiService}schedule/GetNextSchedule/${variables._enteRef}?&callback=?&t=${new Date().getTime()}`).done((data) => {
			const baseUrl = $scadenzeDirectioBox.data('baseurl');
			data.entities.map((day) => {
				day.Value.map((schedule) => {
					schedule.url = baseUrl + schedule.id; // eslint-disable-line no-param-reassign
				});
			});

			scadenzeDirectioTmpl(data.entities, (err, out) => {
				$scadenzeDirectioBox.find('.list-schedule').replaceWith(out);
				$scadenzeDirectioBox.on('click', '.js-toggle-more-schedule', (e) => {
					e.preventDefault();
					const $that = $(e.currentTarget);
					const $ulList = $that.parent().parent();
					const state = $that.data('state');
					if (!(+state)) {
						// Show
						$ulList.find('li.hidden').addClass('visible-element').removeClass('hidden');
						$that.data('state', '1');
						$that.html('nascondi');
					} else {
						// Hide
						$that.data('state', '0');
						$ulList.find('li.visible-element').removeClass('visible-element').addClass('hidden');
						$that.html('altro');
					}
				});
			});
		});
	}

	$('.inactive-tab-agenda').on('click', (evt) => {
		evt.preventDefault();
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/configPage/homepage.js
 **/